<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18vKrar/Images/cover.jpg?1685327423009" alt="This image is the cover for the book Red Runs Through, Piece Us Back Together"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Red Runs Through, Piece Us Back Together
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Piece Us Back Together story</i></b></p><p>Carter McClintock’s life is uncomplicated. For the past five years, he’s spent so much time in hospital scrubs that one day bleeds into the next, and that’s just the way he likes it. That is, until he meets Matthew Nolan. Carter has never had a patient affect him the way Matthew does. During Matthew’s stay in the hospital, the chemistry is unmistakable, and once he is discharged, Carter asks him out.</p> <p>Despite the obvious attraction between them, Matthew’s HIV status keeps him from handing Carter his heart, refusing to believe anyone could ever truly want him. When Matthew’s past comes to light, their budding relationship is threatened before it has even begun. But Carter isn’t one to give up without a fight, and he will do anything to show Matthew the lengths he will go to keep them together.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cate Ashwood
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?80d78ff6